import React from 'react'

const SubHeading = ({ text, className }) => {
    return (
        <h1 className={`text-xl font-[700] ${className}`}>{text}</h1>
    )
}

export default SubHeading